import gql from 'graphql-tag';

const DriverAssignments = gql(/* GraphQL */ `
  query DriverAssignments($eventAtRange: TimeRangeInput) {
    driverAssignments(eventAtRange: $eventAtRange) {
      id
      deliveryStatus
      delivery {
        id
        eventAt
        orderNumber
        pickupAddress {
          id
          timeZoneIdentifier
        }
        dropoffAddress {
          id
          locationName
          street1
          street2
          city
          state
          zip
        }
        dropoffWindow {
          endAt
          startAt
        }
      }
    }
  }
`);

export default DriverAssignments;
